import { render, staticRenderFns } from "./calcolato.vue?vue&type=template&id=610a7b6e"
import script from "./calcolato.vue?vue&type=script&lang=js"
export * from "./calcolato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports